import { render, staticRenderFns } from "./DisneyAgreePopup.vue?vue&type=template&id=64e786a4&scoped=true&"
import script from "./DisneyAgreePopup.vue?vue&type=script&lang=js&"
export * from "./DisneyAgreePopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e786a4",
  null
  
)

export default component.exports